import { RadioButtonGroup } from "@octopusdeploy/design-system-components";
import { withBoundField } from "./BoundField";
export const BoundRadioButtonGroup = withBoundField(RadioButtonGroup);
